import React from 'react';
import theme from './UnitDropdown.module.scss';
import { UnitFilterData } from '@/types';
import Select, { components } from 'react-select';
import { UserIcon, StackedIcons } from '@/components/Icons';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';

const Option = (props) => {
    const data: UnitFilterData = props.data;
    const buyers = data.buyers;
    let buyerNames: string | null = null;
    if (buyers && buyers.length > 1) {
        buyerNames = buyers.map((b) => b.firstName).join(', ');
    } else if (buyers && buyers.length === 1) {
        buyerNames = buyers[0].displayName;
    }
    return (
        <components.Option {...props}>
            <div className={theme.optionContainer}>
                {buyers && (
                    <StackedIcons>
                        {buyers.map((b) => (
                            <UserIcon
                                key={b.userId + '_' + b.displayName}
                                className={theme.userIcon}
                                sizeInPx={30}
                                userId={b.userId}
                            />
                        ))}
                    </StackedIcons>
                )}
                <div className={theme.textSection}>
                    <div className={theme.unitName}>
                        {data.name} {data.groupName && ` - ${data.groupName}`}
                    </div>
                    {buyerNames && <div className={theme.buyers}>{buyerNames}</div>}
                </div>
            </div>
        </components.Option>
    );
};

interface UnitDropdownProps {
    units: UnitFilterData[];
    value: number[];
    onChange(selectedUnits: number[]): void;
}

const UnitDropdown: React.FC<UnitDropdownProps> = ({ units, value, onChange }) => {
    const sortedUnits = units.sort((a, b) => (a.name > b.name ? 1 : -1));
    const fixedOptions = sortedUnits.map((u) => ({ value: u.id, label: u.name, ...u }));
    const fixedValue = fixedOptions.filter((u) => value.some((v) => +v === u.id));

    const handleChange = (newValue, actionMeta: any) => {
        if (!newValue || !Array.isArray(newValue)) {
            onChange([]);
        } else {
            onChange(newValue.map((nw) => nw.value));
        }
    };

    const filterOption = (option, inputValue: string) => {
        const data: UnitFilterData = option.data;
        const checkStrings = [data.groupName ?? '', data.name, ...(data.buyers ?? []).map((b) => b.displayName)];
        return checkStrings.some((s) => s.toLowerCase().includes(inputValue.toLowerCase()));
    };

    return (
        <Select
            classNamePrefix="r-s"
            className="react-select full-width"
            filterOption={filterOption}
            placeholder={t`Any unit`}
            onChange={handleChange}
            isMulti
            value={fixedValue}
            options={fixedOptions}
            components={{ Option }}
        />
    );
};

export default UnitDropdown;

interface UnitFilterProps extends UnitDropdownProps {}

export const UnitFilter: React.FC<UnitFilterProps> = (props) => {
    return (
        <>
            <label className="filter-label">{<Trans>Units</Trans>}</label>
            <UnitDropdown {...props} />
        </>
    );
};
